export default __webpack_public_path__ + "media/zurb/img/services/tools/foundation-screenshot2-fd4f25a082f4d533738c92c1b3f33122.png";